app.filter('yesNo', ['$translate', function ($translate) {
    return function (input) {
        if(input) {
            return $translate.instant('T.UI.APPLICATION.YES');
        } else {
            return $translate.instant('T.UI.APPLICATION.NO');
        }
    };
}]);